import React, { useEffect, useState } from "react";
import NotFound from "../../components/not-found/NotFound";
import EditIcon from "../../comman/action/EditIcon";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { fathSubscriptionListApi } from "../../services/subscription";
import { catchMessage, elseMessage } from "../../comman/Message";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import { dateFormat } from "../../components/Form";

const Subscription = () => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [subscriptionList, setSubscription] = useState([]);

  //------------get-subscription-value----------------
  useEffect(() => {
    const fathSubscriptionList = async () => {
      try {
        showLoader();
        const res = await fathSubscriptionListApi();
        if (res?.data?.status === 200) {
          const data = res?.data?.data?.plan;
          setSubscription(data || []);
          hideLoader();
        } else {
          elseMessage(res);
          hideLoader();
        }
      } catch (err) {
        catchMessage(err);
        hideLoader();
      }
    };
    fathSubscriptionList();
  }, []);

  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Subscription Management</h4>
          </div>
          {/* <div className="FilterBox FilterArea">
                        <div className="form-group search">
                            <input type="search"
                                className="form-control"
                                placeholder='Search'
                                value={search || ""}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                    </div> */}
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Title</th>
                  <th>Plan</th>
                  <th>Amount</th>
                  <th>createdAt</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>

              <tbody>
                {subscriptionList.length > 0 ? (
                  subscriptionList.map(
                    ({ _id, title, type, createdAt, status, price }, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            {/* <td>{++index + (activePage - 1) * 10}</td> */}
                            <td>{++index}</td>
                            <td>{title || "N/A"}</td>
                            <td>{type || "N/A"}</td>
                            <td>{price || "N/A"}</td>
                            <td>{dateFormat(createdAt) || "N/A"}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <EditIcon to={`/subscription/update/${type}`} />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Subscription Found!"
                    icon={<LoyaltyIcon style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          {/* <PaginationShow
                        total={total}
                        activePage={activePage}
                        handlePageChange={handlePageChange}
                    /> */}
        </div>
      </div>
    </>
  );
};

export default Subscription;
